import MaterialBase from './MaterialBase';
import { CORE_COLOR } from '../../../constants/globals';

class Core extends MaterialBase {
}

Core.displayName = 'Core';

Core.defaultProps = {
  color: CORE_COLOR,
};
export default Core;




// WEBPACK FOOTER //
// ./src/components/common/materials/Core.js